import { render } from "./PropertiesPage.vue?vue&type=template&id=9fd1b3d0"
import script from "./PropertiesPage.vue?vue&type=script&lang=js"
export * from "./PropertiesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__